export default {
  updateResources (state, payload) {
    state.resources = []
    let resources = payload.resources

    for (let i in resources) {
      let resource = resources[i]
      state.resources.push(resource)
    }

    state.loading = false
  },
  switchLoading (state, payload) {
    state.loading = payload.state || !state.loading
  },
  updateTopics (state, payload) {
    state.topics = []
    let topics = payload.topics

    for (let i in topics) {
      let topic = topics[i]
      state.topics.push(topic)
    }
  },
  updateResourceTypes (state, payload) {
    state.resourceTypes = []
    let resourceTypes = payload.resourceTypes

    for (let i in resourceTypes) {
      let resourceType = resourceTypes[i]
      state.resourceTypes.push(resourceType)
    }
  },
  updateLanguages (state, payload) {
    state.languages = []
    let languages = payload.languages

    for (let i in languages) {
      let language = languages[i]
      state.languages.push(language)
    }
  },
  setLanguage(state, payload) {
    state.language = payload.lang
  },
}